document.addEventListener('DOMContentLoaded', function () {
  const archiveForm = document.getElementById('archive-form');
  if(archiveForm) {
    archiveForm.addEventListener('submit', function (evt) {
      evt.preventDefault();
    });
    archiveForm.addEventListener('change', function () {
      let filteredAppliedTags = [];
      const selectedYear = archiveForm.year.value;
      const selectedMonth = archiveForm.month.value;

      const nowPath = window.location.pathname;
      const origin = window.location.origin;
      const hasTagApplied = nowPath.includes('/tagged/');


      if(hasTagApplied) {
        const pathParts = nowPath.split('/tagged/');
        filteredAppliedTags = pathParts[1].split('+');

        filteredAppliedTags = filteredAppliedTags.filter((item) => Number.isNaN(Number(item)));
        filteredAppliedTags = filteredAppliedTags.filter((item) => ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].indexOf(item) === -1);

        if(selectedYear) {
          filteredAppliedTags.push(selectedYear);
        }
        if(selectedMonth) {
          filteredAppliedTags.push(selectedMonth);
        }

        if(filteredAppliedTags.length) {
          window.location.href = `${origin}${pathParts[0]}/tagged/${filteredAppliedTags.join('+')}`;
        } else {
          window.location.href = origin + pathParts[0];
        }
      } else {
        if(selectedYear || selectedMonth) {

          if(selectedYear) {
            filteredAppliedTags.push(selectedYear);
          }

          if(selectedMonth) {
            filteredAppliedTags.push(selectedMonth);
          }

          window.location.href = `${origin}${nowPath}/tagged/${filteredAppliedTags.join('+')}`;
        }
      }
    });
  }

  const filterShowMoreTrigger = document.querySelectorAll('.js-show-more-filters');
  if(filterShowMoreTrigger) {
    filterShowMoreTrigger.forEach((item) => {
      const itemList = item.parentNode.querySelectorAll('.js-show-more-item');
      item.addEventListener('click', function () {
        item.classList.toggle('_active');

        if(item.classList.contains('_active')) {
          item.innerText = item.dataset.less;
          itemList.forEach((i)=>{
            i.style.display = 'block';
          });
        } else {
          item.innerText = item.dataset.more;
          itemList.forEach((i)=>{
            i.style.display = 'none';
          });
        }
      });
    });
  }

  const openFilters = document.querySelector('.js-open-filters');
  const closeFilters = document.querySelector('.js-close-filters');
  const filtersGroup = document.querySelector('.js-filters');

  openFilters.addEventListener('click', function () {
    document.documentElement.classList.add('scroll-locked');
    filtersGroup.classList.add('_active');
  });

  closeFilters.addEventListener('click', function () {
    document.documentElement.classList.remove('scroll-locked');
    filtersGroup.classList.remove('_active');
  });

  let lasWindowWidth = window.innerWidth
  window.addEventListener('resize', function () {
    if(lasWindowWidth !== window.innerWidth) {
      lasWindowWidth = window.innerWidth;
      document.documentElement.classList.remove('scroll-locked');
      filtersGroup.classList.remove('_active');
    }
  })
});
